import { ApolloClient, InMemoryCache } from '@apollo/client/core';
import { ApolloLink, concat } from 'apollo-link';
import { HttpLink } from 'apollo-link-http';

const AUTH_TOKEN = 'apollo_token';

const link = new HttpLink({
	uri: process.env.VUE_APP_GRAPHQL_HTTP
});

const authMiddleWare = new ApolloLink((operation, forward) => {
	const token = localStorage.getItem(AUTH_TOKEN);

	operation.setContext({
		headers: {
			authorization: token ? `Bearer ${token}` : ''
		}
	});

	return forward(operation);
});

const client = new ApolloClient({
	// @ts-ignore: Type ‘ApolloLink’ is missing the following properties from type ‘ApolloLink’: onError, setOnErrorts(2739)
	link: concat(authMiddleWare, link),
	uri: process.env.VUE_APP_GRAPHQL_HTTP,
	cache: new InMemoryCache()
});

export default client;
